import Layout from '@/components/Layout'

const personCenter = {
  path: '/personal-center',
  name: 'PersonalCenter',
  component: Layout,
  redirect: '/personal-center/index',
  children: [
    {
      path: 'index',
      name: 'PersonalCenterIndex',
      component: () => import('../views/PersonalCenter/index.vue')
    },
    {
      path: 'detail', //我的信息
      name: 'PersonalCenterDetail',
      component: () => import('@/views/PersonalCenter/detail')
    },
    {
      path: 'entrust', //我的委托
      name: 'PersonalCenterEntrust',
      component: () => import('@/views/PersonalCenter/entrust')
    },
    {
      path: 'security', //帐号安全
      name: 'PersonalCenterSecurity',
      component: () => import('@/views/PersonalCenter/security')
    },
    {
      path: 'password', //修改密码
      name: 'PersonalCenterPassword',
      component: () => import('@/views/PersonalCenter/password')
    },
    // 
    {
      path: 'forget-password', // 修改密码
      name: 'ForgetPassword',
      component: () => import('@/views/PersonalCenter/forgetPassword')
    },
    {
      path: 'material-home', //材料中心
      name: 'MaterialHome',
      component: () => import('@/views/PersonalCenter/material/materialHome')
    },
    {
      path: 'material-upload', //材料上传
      name: 'MaterialUpload',
      component: () => import('@/views/PersonalCenter/material/materialUpload')
    },
    {
      path: 'reset-email', // 修改邮箱
      name: 'PersonalCenterResetEMail',
      component: () => import('@/views/PersonalCenter/resetEMail')
    },
    {
      path: 'reset-mobile', // 修改手机号
      name: 'PersonalCenterResetMobile',
      component: () => import('@/views/PersonalCenter/resetMobile')
    },
    // 
  ]
}

export default personCenter
